import {Validators} from '@angular/forms';

import {AddressValidator, LatinDigitsValidator, OnlyLatinValidator, WhitespaceValidator} from '@spa/validators';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {CountryAutocompleteControl, BaseControl} from '../../../app/shared/classes';

export const AddressIdSelector = 'id';
export const AddressCountrySelector = 'country';
export const AddressCitySelector = 'city';
export const AddressStateSelector = 'state';
export const AddressPostalCodeSelector = 'postalCode';
export const AddressSelector = 'address';
export const AddressTypeSelector = 'addressType';

export const AddressesFormArraySelector = 'addressesArray';

export const AddressControls = (): BaseControl<string | number>[] => {
    return [
        new BaseControl({
            name: AddressIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            hidden: true
        }),
        new CountryAutocompleteControl({
            name: AddressCountrySelector,
            value: null,
            placeholder: 'Country',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.CountryAutocomplete,
            floatingLabelNever: true,
            options: [],
            countries: [],
        }),
        new BaseControl({
            name: AddressCitySelector,
            value: '',
            placeholder: 'City',
            validators: [WhitespaceValidator(), OnlyLatinValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: AddressStateSelector,
            value: '',
            placeholder: 'State',
            validators: [WhitespaceValidator(), OnlyLatinValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: AddressPostalCodeSelector,
            value: '',
            placeholder: 'Postal code',
            validators: [WhitespaceValidator(), LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: AddressSelector,
            value: '',
            placeholder: 'Address',
            validators: [WhitespaceValidator(), AddressValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: AddressTypeSelector,
            value: '',
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text,
            hidden: true
        })
    ];
};
